/**
 * Registry of known external data set slugs (questionnaires + admin CSV import).
 * Default export.
 */
const externalDataSetSlugs = {
  courtDivisions: 'court-divisions',
} as const;

export default externalDataSetSlugs;
